import api from './api';

export const organizationService = {
    getAllOrganizations: async (page = 1, limit = 20, search = '') => {
        const response = await api.get(`/owner/organizations?page=${page}&limit=${limit}&search=${search}`);
        return response.data;
    },

    getOrganizationDetail: async (orgId) => {
        const response = await api.get(`/owner/organizations/${orgId}`);
        return response.data;
    },

    createOrganization: async (payload) => {
        const response = await api.post('/owner/organizations', payload);
        return response.data;
    },

    updateOrganization: async (orgId, payload) => {
        const response = await api.patch(`/owner/organizations/${orgId}`, payload);
        return response.data;
    }
};
